import React from 'react';
import { Field } from 'formik';
import { fieldToTextField } from 'formik-material-ui';
import { FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import Select from '../Select';

const FSelect = (props) => <Select {...fieldToTextField(props)} {...props} />;

const FormikSelect = (props) => {
    const { error, helperText, fullWidth, style, handleChange } = props;

    return (
        <Field style={style} {...props} error={error}>
            {(fieldProps) => {
                const { setFieldValue } = fieldProps.form;
                const onChange = ({ target }) => {
                    const { name, value } = target;
                    setFieldValue(name, value);
                    if (handleChange) handleChange(value);
                };

                return (
                    <>
                        <FSelect
                            variant="outlined"
                            {...fieldProps}
                            {...props}
                            value={fieldProps.field.value}
                            fullWidth={fullWidth}
                            onChange={onChange}
                        />
                        {error && (
                            <FormHelperText error={true}>
                                {helperText}
                            </FormHelperText>
                        )}
                    </>
                );
            }}
        </Field>
    );
};

export default FormikSelect;

FormikSelect.propTypes = {
    error: PropTypes.bool,
    helperText: PropTypes.string,
    style: PropTypes.any,
    value: PropTypes.any,
    fullWidth: PropTypes.bool,
};

FormikSelect.defaultProps = {
    error: false,
    helperText: null,
    value: null,
    fullWidth: true,
};
